export const getQueryParam = (param: string, url?: string) => {
  if (!url) {
    return undefined;
  }

  const regex = new RegExp(`${param}=([^&]*)`);
  const matches = url.match(regex);

  return matches && matches.length === 2 ? matches[1] : undefined;
};

export const addQueryParam = (param: string, value: string | number, url: string) => {
  const _url = url.split('?');

  if (_url.length <= 1) {
    return `${url}?${param}=${value}`;
  } else {
    return `${url}&${param}=${value}`;
  }
};

export const setQueryParam = (param: string, value: string | number, url: string) => {
  const regex = new RegExp(`${param}=([^&]*)`);
  const matches = url.match(regex);

  return matches && matches.length === 2
    ? url.replace(`${param}=${matches[1]}`, `${param}=${value}`)
    : addQueryParam(param, value, url);
};

export const toQueryStringObject = (url: string) => {
  const parts = url.split('?');
  const search = parts.length <= 1 ? parts[0] : parts[1];

  if (!search) {
    return {};
  }

  const params = search.split('&');
  const obj = {} as Record<string, string[]>;
  return params.reduce((acc, param) => {
    const [name, value] = param.split('=');
    const arr = acc[name] || [];
    if (!acc[name]) {
      acc[name] = arr;
    }
    arr.push(value);
    return acc;
  }, obj);
};

export const fromQueryStringObject = (
  queryStringObject: Record<string, string[]>,
  prefix = '?',
) => {
  const queryString = Object.keys(queryStringObject)
    .reduce(
      (acc, param) =>
        acc.concat(queryStringObject[param].map((value) => `${param}=${value}`).join('&')),
      [] as string[],
    )
    .join('&');

  return `${(queryString && prefix) || ''}${queryString}`;
};
